export default __webpack_public_path__ + "static/media/one.dfd0138d.svg";